import React from 'react';
import { Search } from 'lucide-react';
import CustomSelect from '../../ui/CustomSelect';

interface DocumentListFiltersProps {
  searchTerm: string;
  filterModule: string;
  filterStatus: string;
  onSearchChange: (value: string) => void;
  onModuleChange: (value: string) => void;
  onStatusChange: (value: string) => void;
}

const MODULE_OPTIONS = [
  { value: 'all', label: 'Semua Modul' },
  { value: 'HRIS', label: 'HRIS' },
  { value: 'CREDIT', label: 'Kredit' },
  { value: 'DEBTOR', label: 'Debitur' },
  { value: 'LEGAL', label: 'Legal' },
  { value: 'GENERAL', label: 'General' },
];

const STATUS_OPTIONS = [
  { value: 'all', label: 'Semua Status' },
  { value: 'draft', label: 'Draft' },
  { value: 'pending_validation', label: 'Pending' },
  { value: 'valid', label: 'Valid' },
  { value: 'expired', label: 'Expired' },
  { value: 'rejected', label: 'Rejected' },
];

export default function DocumentListFilters({
  searchTerm,
  filterModule,
  filterStatus,
  onSearchChange,
  onModuleChange,
  onStatusChange,
}: DocumentListFiltersProps) {
  return (
    <div className="grid md:grid-cols-3 gap-4">
      <div className="w-full bg-white rounded-lg shadow-md p-4">
        <div className="relative">
          <Search className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400 pointer-events-none z-10" />
          <input
            type="text"
            placeholder="Cari dokumen..."
            value={searchTerm}
            onChange={e => onSearchChange(e.target.value)}
            className="w-full pl-10 pr-4 py-2.5 bg-white border border-gray-200 rounded-lg text-sm placeholder:text-gray-400 focus:outline-none focus:border-blue-500 focus:ring-1 focus:ring-blue-500"
          />
        </div>
      </div>

      <div className="w-full bg-white rounded-lg shadow-md p-4">
        <CustomSelect
          value={filterModule}
          onChange={onModuleChange}
          options={MODULE_OPTIONS}
          placeholder="Pilih Modul"
          width="w-full"
          color="blue"
        />
      </div>

      <div className="w-full bg-white rounded-lg shadow-md p-4">
        <CustomSelect
          value={filterStatus}
          onChange={onStatusChange}
          options={STATUS_OPTIONS}
          placeholder="Pilih Status"
          width="w-full"
          color="blue"
        />
      </div>
    </div>
  );
}
